if (typeof window.tabKeyPressed === 'undefined') {
  window.tabKeyPressed = false;
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Tab') {
      window.tabKeyPressed = true;
    }
  });
  window.addEventListener('mousedown', () => {
    window.tabKeyPressed = false;
  });
  window.addEventListener('touchstart', () => {
    window.tabKeyPressed = false;
  });
}
if (!customElements.get('bz-product-info')) {
  customElements.define(
    'bz-product-info',
    class BzProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      constructor() {
        super();
        this.quantityInput = this.querySelector('.qty-input');
      }  
          
      // initCustomSlider() {
      //   const items = [...this.querySelectorAll('.bz_product_media')];
      //   if (items.length === 0) return;

      //   let selectedIndex = items.findIndex(i => i.classList.contains('active'));
      //   if (selectedIndex === -1) selectedIndex = 0;

      //   items.forEach(i => i.classList.remove('active'));
      //   items[selectedIndex].classList.add('active');

      //   let index = selectedIndex;

      //   /* ---------------- Dots Container ---------------- */
      //   const dotsContainer = this.querySelector('.media-dots');

      //   if (!dotsContainer) return;
      //   dotsContainer.innerHTML = '';

      //   /* ---------------- Update Active ---------------- */
      //   const updateActive = (newIndex) => {
      //       const oldIndex = index;
      //       if (newIndex === oldIndex) return;

      //       items.forEach(i => i.classList.remove('active'));
      //       dotsContainer.querySelectorAll('.media-dot').forEach(d => d.classList.remove('active'));

      //       items[newIndex].classList.add('active');
      //       dotsContainer.querySelectorAll('.media-dot')[newIndex].classList.add('active');

      //       index = newIndex;
      //   };

      //   const resetToSelected = () => updateActive(index);

      //   /* ---------------- Create Dots ---------------- */
      //   items.forEach((item, i) => {
      //       const dot = document.createElement('span');
      //       dot.classList.add('media-dot');
      //       if (i === selectedIndex) dot.classList.add('active');

      //       dot.addEventListener('mouseenter', () => {
      //           updateActive(i);
      //       });

      //       dotsContainer.appendChild(dot);
      //   });

      //   dotsContainer.addEventListener('mouseleave', resetToSelected);

      //   /* ---------------- Swipe Support ---------------- */
      //   let touchStartX = 0;
      //   let touchEndX = 0;

      //   this.addEventListener('touchstart', (e) => {
      //       touchStartX = e.touches[0].clientX;
      //   }, { passive: true });

      //   this.addEventListener('touchmove', (e) => {
      //       touchEndX = e.touches[0].clientX;
      //   }, { passive: true });

      //   this.addEventListener('touchend', () => {
      //       const swipeDistance = touchEndX - touchStartX;

      //       if (Math.abs(swipeDistance) < 40) return;

      //       if (swipeDistance < 0) {
      //           let next = index + 1;
      //           if (next >= items.length) next = items.length - 1;
      //           updateActive(next);
      //       }

      //       if (swipeDistance > 0) {
      //           let prev = index - 1;
      //           if (prev < 0) prev = 0;
      //           updateActive(prev);
      //       }
      //   });
      // }

   
      // Kruti code
      // initCustomSlider() {
      //   const slider = this;
      //   const items = [...slider.querySelectorAll('.bz_product_media')];
      //   if (!items.length) return;

      //   let index = items.findIndex(i => i.classList.contains('active'));
      //   if (index === -1) {
      //       index = 0;
      //       items[0].classList.add('active');
      //   }

      //   const dotsContainer = slider.querySelector('.media-dots');
      //   if (!dotsContainer) return;
      //   dotsContainer.innerHTML = '';

      //   /* ---------------- Reset Classes ---------------- */
      //   const resetClasses = () => {
      //       items.forEach(i =>
      //           i.classList.remove('slide-in-right', 'slide-out-left')
      //       );
      //   };

      //   /* ---------------- Apply Relative Classes ---------------- */
      //   const applyRelativeClasses = () => {
      //       resetClasses();

      //       const prevItem = items[index - 1];
      //       const nextItem = items[index + 1];

      //       if (prevItem) prevItem.classList.add('slide-out-left');
      //       if (nextItem) nextItem.classList.add('slide-in-right');
      //   };

      //   /* ---------------- Change Active ---------------- */
      //   const setActive = (newIndex) => {
      //       if (newIndex === index) return;

      //       items[index].classList.remove('active');
      //       index = newIndex;
      //       items[index].classList.add('active');

      //       dotsContainer.querySelectorAll('.media-dot')
      //           .forEach(d => d.classList.remove('active'));
      //       dotsContainer.querySelectorAll('.media-dot')[index]
      //           .classList.add('active');

      //       applyRelativeClasses();
      //   };

      //   /* ---------------- Init ---------------- */
      //   applyRelativeClasses();

      //   /* ---------------- Dots ---------------- */
      //   items.forEach((_, i) => {
      //       const dot = document.createElement('span');
      //       dot.className = 'media-dot' + (i === index ? ' active' : '');
      //       dot.addEventListener('mouseenter', () => setActive(i));
      //       dotsContainer.appendChild(dot);
      //   });

      //   /* 🔁 RESET TO FIRST ON MOUSE LEAVE */
      //   dotsContainer.addEventListener('mouseleave', () => {
      //       setActive(0);
      //   });

      //   /* ---------------- Swipe ---------------- */
      //   let startX = 0;

      //   slider.addEventListener('touchstart', e => {
      //       startX = e.touches[0].clientX;
      //   }, { passive: true });

      //   slider.addEventListener('touchend', e => {
      //       const endX = e.changedTouches[0].clientX;
      //       const diff = endX - startX;

      //       if (Math.abs(diff) < 40) return;

      //       if (diff < 0 && index < items.length - 1) {
      //           setActive(index + 1);
      //       }

      //       if (diff > 0 && index > 0) {
      //           setActive(index - 1);
      //       }
      //   });
      // }


      initCustomSlider() {
        const sliderEl = this.querySelector(`.bzcard_slide.bzcard_slide-${this.dataset.section}-${this.dataset.productId}`);
        if (sliderEl) {
          new Swiper(sliderEl, {
            spaceBetween: 50,
            pagination: {
              el: sliderEl.querySelector('.swiper-pagination'),
              clickable: true,
            },
            nested: true,
          });
        }
      }

      connectedCallback() {
        this.initializeProductSwapUtility();
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );
        this.initQuantityHandlers();

        this.dispatchEvent(new CustomEvent('bz-product-info:loaded', { bubbles: true }));
        const variant = this.getSelectedVariant(this);
        if (this.dataset.layout == 'card') this.updateCardMedia(variant?.featured_media?.id);
        if (this.querySelector(`.bzcard_slide-${this.dataset.section}-${this.dataset.productId}`)) {
          this.initCustomSlider();
        }
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }
      initQuantityHandlers() {
        if (!this.quantityInput) return;
        this.quantityForm = this.querySelector('.product_qty');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }
      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }
      initializeProductSwapUtility() {
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }
      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        // if (!this.contains(event.target)) return;
        const closestProductInfo = event.target.closest('bz-product-info');
        if (closestProductInfo !== this) return;
        this.resetProductFormState();
        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct && this.dataset.layout != 'card';
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct && this.dataset.layout != 'card'
          ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
          : this.handleUpdateProductInfo(productUrl),
          focusId: target.dataset.optionValueId,
        });
      }
      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }
      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();
          const selector = updateFullPage ? "bz-product-info[id^='Products']" : 'bz-product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);
          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('bz-product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }
      renderProductInfo({ requestUrl, targetId, callback, focusId }) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            if (this.dataset.layout == 'card') {
              var wc_forloop_index = parseInt(document.querySelector(`#${targetId}`).getAttribute('data-forloop-index'));
              const originalHtml = new DOMParser().parseFromString(responseText, 'text/html');
              const html = originalHtml.getElementById(this.id) ? originalHtml.getElementById(this.id) : originalHtml;
              if (wc_forloop_index >= 0) {
                html.querySelectorAll('.bz_select_operation').forEach(function(self, index){
                  self.setAttribute('data-forloop-index', wc_forloop_index);
                  var wc_name_attr = self.getAttribute('name');
                  self.setAttribute('name', wc_name_attr + wc_forloop_index);
                });
              }
              callback(html);
            }else{
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              if(html.tagNam == 'bz-product-info') html.setAttribute('data-update-url', 'false')
              else if(html.querySelector('BZ_PRODUCT_INFO') && this.dataset.isQuickView) {
                html.querySelector('bz-product-info').setAttribute('data-update-url', 'false');
                html.querySelector('bz-product-info').setAttribute('data-is-quick-view', 'true');
              }
              callback(html);
            }
          })
          .then(() => {
            if (tabKeyPressed) {
              this.dataset.layout != 'card' ? document.querySelector(`#${targetId}`)?.focus() : document.querySelector('input[data-option-value-id="'+focusId+'"]')?.focus();
            }
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }
      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('wb-variant-select [data-selected-variant]')?.innerHTML || productInfoNode.querySelector('wb-color-swatch [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }
      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];
        !shouldFetchFullPage && params.push(`section_id=${this.dataset.originalSection}`); //params.push(`section_id=${this.sectionId}`);
        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }
        return `${url}${url.indexOf('?') >= 0 ? '&' : '?'}${params.join('&')}`;
      }
      updateOptionValues(html) {
        const variantSelects = html.querySelector('wb-variant-select');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }
      updateCardVendor(vendorName) {
        const card = this.closest('.card') || this.querySelector('.card');
        if (!card) return;
        const vendorElement = card.querySelector('.card_vendor');
        if (vendorElement) {
          vendorElement.textContent = vendorName;
        }
      }
      updateCardProductType(productType) {
        const productTypeElement = this.querySelector('.card_type');
        if (productTypeElement) {
          productTypeElement.textContent = productType;
        }
      }
      updateCardTitle(productTitle) {
        const productTitleElement = this.querySelector('.card_ajax_heading');
        if (productTitleElement) {
          productTitleElement.textContent = productTitle;
        }
      }
      updateCardSku(productSku) {
        const productSkuElement = this.querySelector('.sku-data');
        if (productSkuElement) {
          productSkuElement.textContent = productSku;
        }       
        const skuElement = this.querySelector(`#Sku-${this.dataset.section}`);
        if (skuElement) {
          skuElement.classList.remove('hidden');
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          const quantityWrap = this.querySelector('.product_qty .quantity-wrap');
          if (quantityWrap && variant?.id) {
            quantityWrap.setAttribute('data-key', variant.id);
          }

          const vendorName = html.querySelector('.card_vendor')?.textContent;
          if (vendorName) {
            this.updateCardVendor(vendorName);
          } else {
            this.updateCardVendor('');
          }
          const productType = html.querySelector('.card_type')?.textContent;
          if (productType) {
            this.updateCardProductType(productType);
          } else {
            this.updateCardProductType('');
          }
          
          const productJsonData = html.querySelector('[data-selected-ajax]');
          const productDataObject = productJsonData ? JSON.parse(productJsonData.textContent) : null;
          
          if(productDataObject){
            this.updateCardTitle(productDataObject.name);
            this.updateCardVendor(productDataObject.vendor);
            this.updateCardSku(productDataObject.sku);
          }          
          
          if (this.dataset.layout == 'card') {
            if (this.dataset.url != productUrl) {
              const productMediaItem  = html.querySelectorAll(".bz_product_media");
              productMediaItem.forEach((mediaItem) => {
                mediaItem.dataset.mediaId = this.replaceStringBeforeLastDash(mediaItem.dataset.mediaId, `${this.dataset.section}-${this.dataset.productId}`);
              });
              // this.querySelector(".card-media").innerHTML = html.querySelector(".card-media").innerHTML;
              const destMedia = this.querySelector(".bz_list_media, .card-media");
              const srcMedia = html.querySelector(".bz_list_media, .card-media");
              if (destMedia && srcMedia) destMedia.innerHTML = srcMedia.innerHTML;
            }
            this.dataset.url = productUrl;
          }
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);
          const cardVariants = this.querySelector('wb-card-variants');
          if (cardVariants && typeof cardVariants.updateTrigger === 'function' && variant) {
            const optionName = this.querySelector('wb-variant-select')?.dataset.triggerName || '';
            const optionValue = variant.options?.[0] || '';
            if (window.variantStrings?.yourOption && optionName && optionValue) {
              cardVariants.updateTrigger(
                window.variantStrings.yourOption.replace('[name]', optionName).replace('[value]', optionValue)
              );
            }
          }
          if (!variant) {
            this.setUnavailable();
            return;
          }
          if (variant.id && this.dataset.isQuickView) {
            this.querySelector('input.product-variant-id[name="id"]').setAttribute('value', variant.id);
          }
          this.updateMedia(html, variant?.featured_media?.id);
          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.querySelector(`#${id}-${this.sectionId}`);
            var main_url_1 = `#${id}-${this.dataset.section}`;
            var main_url_2 = `#${id}-quickadd-${this.dataset.section}`;
            const destination = this.querySelector(main_url_1) ? this.querySelector(main_url_1) : this.querySelector(main_url_2);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };
          updateSourceFromDestination('price');          
          const stickyCart = document.querySelector('.sticky_pro_page');
          if (stickyCart) {
            const sectionId = stickyCart.dataset.sectionId; 
            const stickyCartPrice = stickyCart.querySelector(`#price-${sectionId}`);
            if (stickyCartPrice) {
              const newPrice = html.querySelector(`#price-${this.sectionId}`)?.innerHTML;
              if (newPrice) {
                stickyCartPrice.innerHTML = newPrice;
              }
            }
          }          
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('badge', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));
          // this.updateQuantityRules(this.sectionId, html);
          if (this.querySelector(`#Quantity-Rules-${this.dataset.section}`)) {
            this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          } else {
            this.querySelector(`#Quantity-Rules-quickadd-${this.dataset.section}`)?.classList.remove('hidden');
          }
          if (this.querySelector(`#Volume-Note-${this.dataset.section}`)) {
            this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');
          } else {
            this.querySelector(`#Volume-Note-quickadd-${this.dataset.section}`)?.classList.remove('hidden');
          }
          if (html.querySelector(`#ProductSubmitButton-${this.sectionId}`)) {
            html.querySelectorAll('.bz_product_input.bz_product_pills, .bz_product_input.bz_product_swatch, .bz_form_input.bz_product_input, .bz_product_input.bz_product_dropdown').forEach(function(self, index){
             let radioCheckedValue = self.querySelector('input.input_radio:checked');
              if (radioCheckedValue) {
                let value = radioCheckedValue.getAttribute('value');
                if (value !== variant.options[index]) {
                  fullSelected = 0;
                }
              }
              if (self.querySelector('select')) {
                const selectedOption = self.querySelector('select').selectedOptions[0];
                var selectedValue = selectedOption.getAttribute('value');
                if (selectedValue !== variant.options[index]) {
                  fullSelected = 0;
                }
              }
            });
            if (fullSelected == 0) {
              this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);
            } else {
              this.productForm?.toggleSubmitButton(
                html.querySelector(`#ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
                window.variantStrings.soldOut
              );
            }
          } else {
            var fullSelected = 1;
            html.querySelectorAll('.bz_product_input.bz_product_pills, .bz_form_input.bz_product_input').forEach(function(self, index){
               if (self.querySelector('input.input_radio:checked')){
                if (self.querySelector('input.input_radio:checked').getAttribute('value') !== variant.options[index]) {
                  fullSelected = 0;
                }
               }
               if (self.querySelector('select')) {
                const selectedOption = self.querySelector('select').selectedOptions[0];
                var selectedValue = selectedOption.getAttribute('value');
                if (selectedValue !== variant.options[index]) {
                  fullSelected = 0;
                }
              }
            });
            if (fullSelected == 0) {
              this.productForm?.toggleSubmitButton(
                true,
                window.variantStrings.unavailable
              );
            } else {
              this.productForm?.toggleSubmitButton(
                html.querySelector(`#ProductSubmitButton-quickadd-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
                window.variantStrings.soldOut
              );
            }
          }
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }
      updateVariantInputs(variantId) {
        const selecter = this.dataset.layout == 'card' ? this.dataset.section + "-" + this.dataset.productId : this.dataset.section
        const forms = this.querySelectorAll(
          `#product-form-${selecter}, #product-form-installment-${selecter}`
        );
        const inputs = forms.length
          ? forms
          : this.querySelectorAll('form[action*="/cart/add"]');
        inputs.forEach((productForm) => { 
          const input = productForm.querySelector('input[name="id"]');
          if (!input) return;
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );
        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }
      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);
        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        this.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }
      updateCardMedia(variantFeaturedMediaId){
        if (!variantFeaturedMediaId) return;
          const mediaRoot = this.querySelector('.bz_list_media') || this.querySelector('.card-media') || this.closest('.card') || this.querySelector('.card') || this;
          const newMedia = mediaRoot.querySelector(
            `[data-media-id="${this.dataset.section}-${this.dataset.productId}-${variantFeaturedMediaId}"]`
          );
          if (!newMedia) return;
          const parent = newMedia.parentElement;
          if (!parent || parent.firstChild == newMedia) return;
          parent.prepend(newMedia);
      }
      
      replaceStringBeforeLastDash(str, replacement) {
        const lastDashIndex = str.lastIndexOf('-');
        if (lastDashIndex === -1) {
          return str;
        }
        return replacement + str.substring(lastDashIndex);
      }
      
      // Working js final [don't change anything inside of this part] ===============
      updateMedia(html, variantFeaturedMediaId) {
          if (!variantFeaturedMediaId) return;

          if (this.dataset.layout == 'card') {
              this.updateCardMedia(variantFeaturedMediaId);
          } else {
              // const mediaGallerySource = this.querySelector('bz-product-media ul.main_list');
              // const thumbGallerySource = this.querySelector('bz-product-media ul.thumb_list');
              // const mediaGalleryDestination = html.querySelector('bz-product-media ul.main_list');
              // const thumbGalleryDestination = html.querySelector('bz-product-media ul.thumb_list');
            const mediaGallerySource = this.querySelector('bz-product-media .main_list');
              const thumbGallerySource = this.querySelector('bz-product-media .thumb_list');
              const mediaGalleryDestination = html.querySelector('bz-product-media .main_list');
              const thumbGalleryDestination = html.querySelector('bz-product-media .thumb_list');

              const refreshSourceData = (gallery) => {
                  // const items = Array.from(gallery.querySelectorAll('li[data-media-id]'));
                  const items = Array.from(gallery.querySelectorAll(':scope > [data-media-id]'));
                  const set = new Set(items.map(item => item.dataset.mediaId));
                  const map = new Map(items.map((item, index) => [item.dataset.mediaId, { item, index }]));
                  return [items, set, map];
              };

              if (mediaGallerySource && mediaGalleryDestination) {
                  let [sourceItems, sourceSet, sourceMap] = refreshSourceData(mediaGallerySource);
                  // const destinationItems = Array.from(mediaGalleryDestination.querySelectorAll('li[data-media-id]'));
                  const destinationItems = Array.from(mediaGalleryDestination.querySelectorAll(':scope > [data-media-id]'));
                  const destinationSet = new Set(destinationItems.map(item => item.dataset.mediaId));
                  let shouldRefresh = false;
                  for (let i = destinationItems.length - 1; i >= 0; i--) {
                      if (!sourceSet.has(destinationItems[i].dataset.mediaId)) {
                          mediaGallerySource.prepend(destinationItems[i]);
                          shouldRefresh = true;
                      }
                  }
                  for (let i = 0; i < sourceItems.length; i++) {
                      if (!destinationSet.has(sourceItems[i].dataset.mediaId)) {
                          sourceItems[i].remove();
                          shouldRefresh = true;
                      }
                  }
                  if (shouldRefresh) {
                      [sourceItems, sourceSet, sourceMap] = refreshSourceData(mediaGallerySource);
                  }
                  destinationItems.forEach((destItem, destIndex) => {
                    const sourceData = sourceMap.get(destItem.dataset.mediaId);
                    if (sourceData && sourceData.index !== destIndex) {
                      mediaGallerySource.insertBefore(
                          sourceData.item,
                          // mediaGallerySource.querySelector(`li:nth-of-type(${destIndex + 1})`)
                          mediaGallerySource.children[destIndex] || null
                      );
                      [sourceItems, sourceSet, sourceMap] = refreshSourceData(mediaGallerySource);
                    }
                  });
              }

              /* ---------------- Thumbnail gallery update ---------------- */
              if (thumbGallerySource && thumbGalleryDestination) {
                  let [thumbItems, thumbSet, thumbMap] = refreshSourceData(thumbGallerySource);
                  // const thumbDestinationItems = Array.from(thumbGalleryDestination.querySelectorAll('li[data-media-id]'));
                  const thumbDestinationItems = Array.from(thumbGalleryDestination.querySelectorAll(':scope > [data-media-id]'));
                  const thumbDestinationSet = new Set(thumbDestinationItems.map(item => item.dataset.mediaId));
                  let shouldRefreshThumb = false;
                  for (let i = thumbDestinationItems.length - 1; i >= 0; i--) {
                      if (!thumbSet.has(thumbDestinationItems[i].dataset.mediaId)) {
                          thumbGallerySource.prepend(thumbDestinationItems[i]);
                          shouldRefreshThumb = true;
                      }
                  }
                  for (let i = 0; i < thumbItems.length; i++) {
                      if (!thumbDestinationSet.has(thumbItems[i].dataset.mediaId)) {
                          thumbItems[i].remove();
                          shouldRefreshThumb = true;
                      }
                  }
                  if (shouldRefreshThumb) {
                      [thumbItems, thumbSet, thumbMap] = refreshSourceData(thumbGallerySource);
                  }
                  thumbDestinationItems.forEach((destItem, destIndex) => {
                      const sourceData = thumbMap.get(destItem.dataset.mediaId);
                      if (sourceData && sourceData.index !== destIndex) {
                          thumbGallerySource.insertBefore(
                              sourceData.item,
                              // thumbGallerySource.querySelector(`li:nth-of-type(${destIndex + 1})`)
                              thumbGallerySource.children[destIndex] || null
                          );
                          [thumbItems, thumbSet, thumbMap] = refreshSourceData(thumbGallerySource);
                      }
                  });
              }
              /* ---------------- Swiper reset to FIRST slide on variant change ---------------- */
              const thumbSwiperEl = this.querySelector('.product_thumbs');
              const mainSwiperEl = this.querySelector('.main_slider');

              if (mainSwiperEl?.swiper) {
                const mainSwiper = mainSwiperEl.swiper;
                mainSwiper.update();
                mainSwiper.slideTo(0, 0);
              }
              if (thumbSwiperEl?.swiper) {
                const thumbSwiper = thumbSwiperEl.swiper;
                thumbSwiper.update();
                thumbSwiper.slideTo(0, 0);
                thumbSwiper.slides.forEach(slide =>
                    slide.classList.remove('swiper-slide-thumb-active')
                );
                if (thumbSwiper.slides[0]) {
                    thumbSwiper.slides[0].classList.add('swiper-slide-thumb-active');
                }
              }
              /* ---------------- Set main image active ---------------- */
              const selector = this.dataset.isQuickView ? 'quickadd-' : '';
              const bzMedia = this.querySelector('bz-product-media');
              bzMedia?.setActiveMedia?.(`${selector}${this.dataset.section}-${variantFeaturedMediaId}`, true);
          }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };
        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);
        this.quantityInput.min = min;
        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }
      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e));
      }
      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();
        const quantityFormUpdated = html.querySelector(`#Quantity-Form-${sectionId}`);
        const selectors = ['.qty-input', '.qty_rules', '.qty_label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.qty-input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
      get productForm() {
        return this.querySelector(`product-form`);
      }
      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }
      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }
      get variantSelectors() {
        return this.querySelector('wb-variant-select') || this.querySelector('wb-color-swatch');
      }
      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }
      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }
      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}

if (!customElements.get('wb-card-variants')) {
  customElements.define(
    'wb-card-variants',
    class WbCardVariants extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-variant-trigger]');
        this.closeBtn = this.querySelector('[data-variant-close]');
        this.triggerText = this.querySelector('.card-variant-trigger-text');
        this.onTriggerClick = this.open.bind(this);
        this.onCloseClick = this.close.bind(this);
        this.onDocumentClick = this.handleOutsideClick.bind(this);
        this.trigger?.addEventListener('click', this.onTriggerClick);
        this.closeBtn?.addEventListener('click', this.onCloseClick);
        this.onKeydown = (event) => {
          if (event.key === 'Escape' && this.classList.contains('is-open')) {
            event.stopPropagation();
            this.close();
          }
        };
        this.addEventListener('keydown', this.onKeydown);
      }
      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.onTriggerClick);
        this.closeBtn?.removeEventListener('click', this.onCloseClick);
        this.removeOutsideListener();
      }
      handleOutsideClick(event) {
        if (this.contains(event.target)) return;
        this.close();
      }
      addOutsideListener() {
        if (this.outsideBound) return;
        this.outsideBound = true;
        document.addEventListener('click', this.onDocumentClick);
      }
      removeOutsideListener() {
        if (!this.outsideBound) return;
        this.outsideBound = false;
        document.removeEventListener('click', this.onDocumentClick);
      }
      open() {
        document.querySelectorAll('wb-card-variants.is-open').forEach((el) => {
          if (el !== this) el.close();
        });
        this.classList.add('is-open');
        this.trigger?.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => this.addOutsideListener());
        // The trigger hides while open: move focus into the panel so it is not lost
        if (this.trigger && this.trigger === document.activeElement) {
          setTimeout(() => {
            const panel = this.querySelector('.card-variant-overlay') || this;
            const target = window.BzA11y?.getFocusable(panel).find((el) => !el.matches('[data-variant-close]'))
              || this.closeBtn;
            target?.focus({ preventScroll: true });
          }, 60);
        }
      }
      close() {
        const hadFocus = this.contains(document.activeElement) && document.activeElement !== this.trigger;
        this.classList.remove('is-open');
        this.trigger?.setAttribute('aria-expanded', 'false');
        this.removeOutsideListener();
        if (hadFocus) this.trigger?.focus({ preventScroll: true });
      }
      updateTrigger(label) {
        if (this.triggerText && label) {
          this.triggerText.innerHTML = label;
        }
      }
    }
  );
}

// homepage product grid variant change to not remove checked in the radio button
document.addEventListener("change", function (event) {
  if (event.target.classList.contains("bz_select_operation")) {
    let closestFeature = event.target.closest(".bz_feat_collection");
    if (!closestFeature) return;
    let dataId = closestFeature.getAttribute("data-id");
    setTimeout(() => {
      let radioButtons = closestFeature.querySelectorAll(
        ".bz_select_operation"
      );
      radioButtons.forEach((radio) => {
        let originalName =
          radio.getAttribute("data-original-name") ||
          radio.getAttribute("name");
        radio.setAttribute("data-original-name", originalName);
        radio.setAttribute("name", `${originalName}_${dataId}`);
      });
    }, 1000);
  }
});